export default {
    getDonationSteps: (state, getters) => {
        let donationAmountInvalid = !state.stepsValidationState.donationAmount

        let paymentTypeDisabled = false || donationAmountInvalid
        let paymentTypeInvalid = !state.stepsValidationState.paymentType

        let contactDataDisabled = false || donationAmountInvalid || paymentTypeInvalid
        let contactDataHidden = !(state.donationData.sendDonationReceipt || getters.askOptionalData || getters.paymentTypeDirectDebit)
        let contactDataInvalid = !contactDataHidden && !state.stepsValidationState.contactData

        let summaryDisabled = false || donationAmountInvalid || paymentTypeInvalid || contactDataInvalid

        return [
            {name: "donationAmount", disabled: false, hidden: false, valid: !donationAmountInvalid},
            {name: "paymentType", disabled: paymentTypeDisabled, hidden: false, valid: !paymentTypeInvalid},
            {
                name: "contactData",
                disabled: contactDataDisabled,
                hidden: contactDataHidden,
                valid: !contactDataInvalid
            },
            {name: "summary", disabled: summaryDisabled, hidden: false, valid: true}
        ].map(step => {
                return {...step, touched: state?.stepsTouched?.includes(step.name)}
            }
        )
    },

    askOptionalData: (state, getters) => {
        return state.projectData?.fundraisingBaseData?.optionalData
    },

    paymentTypeDirectDebit: (state, getters) => {
        const availablePaymentTypes = state.projectData?.availablePaymentTypes
        const selectedPaymentType = state.donationData?.paymentData?.paymentType
        return availablePaymentTypes?.find(availablePaymentType => availablePaymentType.id === selectedPaymentType)?.type?.id === 1 ?? false
    },

    getSelectedPaymentType: (state, getters) => {
        if (!state.donationData?.paymentData?.paymentType) return null
        return state.projectData?.availablePaymentTypes?.find(
            availablePaymentType => availablePaymentType.id === state.donationData?.paymentData?.paymentType
        ) ?? null
    },

    getCurrentDonationFees: (state, getters) => {
        let selectedPaymentType = getters.getSelectedPaymentType
        if (!state.donationData?.donationAmount || !selectedPaymentType) return null
        if (!selectedPaymentType.fixedFees && !selectedPaymentType.relativeFees) return null
        let fixedFeeAmount = selectedPaymentType.fixedFees ?? 0
        let relativeFeeAmount = state.donationData?.donationAmount * ((selectedPaymentType.relativeFees ?? 0) / 100)
        return roundFeeValue(fixedFeeAmount + relativeFeeAmount)
    }
}

function roundFeeValue(amount = 0) {
    return Math.round(Math.ceil(amount * 10)) / 10
}